var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-download"},[_c('div',{staticClass:"dev-download-left"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.download.name))]),_c('div',{staticClass:"version"},[_vm._v("Versión "+_vm._s(_vm.download.version))])]),_c('div',{staticClass:"dev-download-right"},[_c('DownloadButton',{attrs:{"download":_vm.download}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }